import { createContext } from 'react';

export const EstabelecimentoContext = createContext({});
